"use strict";
import * as e from './echart_utils.js';
import * as echarts from 'echarts';

// Default values
var relay = 'polkadot';
var check = 'all';
var currentTheme = localStorage.getItem('theme') || 'light';
var chartsConfig = update_chartsConfig(relay, check, currentTheme);

function jsonToPlainStringGeneric(jsonData) {
    const columnNames = Object.keys(jsonData);
    const ids = Object.keys(jsonData[columnNames[0]]);

    let result = "| " + columnNames.join(" | ") + " |\n";

    ids.forEach(id => {
        const row = columnNames.map(column => {
            const value = jsonData[column][id];
            return value === null ? 'N/A' : value;
        }).join(" | ");
        result += "| " + row + " |\n";
    });

    return result;
}

document.addEventListener('DOMContentLoaded', () => {
  const toggleSwitch = document.querySelector('.theme-switch input[type="checkbox"]');

  document.querySelectorAll('input[name="relaySelection"]').forEach(function(radio) {
    radio.onchange = function() {
      chartsConfig = update_chartsConfig(relay = this.value, check = check, currentTheme);
    };
  });
  document.querySelectorAll('input[name="checkSelection"]').forEach(function(radio) {
    radio.onchange = function() {
      chartsConfig = update_chartsConfig(relay = relay, check = this.value, currentTheme);
    };
  });

  toggleSwitch.addEventListener('change', (e) => {
      currentTheme = e.target.checked ? 'dark' : 'light';
      localStorage.setItem('theme', currentTheme); 
      document.body.classList.toggle('dark-mode', currentTheme === 'dark');
      update_chartsConfig(relay, check, currentTheme); 
  });

  if (localStorage.getItem('theme') === 'dark') {
      toggleSwitch.checked = true;
      document.body.classList.add('dark-mode');
  }
  update_chartsConfig(relay, check, currentTheme);
});

function update_chartsConfig(relay, check, currentTheme) {

  chartsConfig = [
    {
        elementId: 'tableMetadata',
        jsonPath: 'data/metadata000000000000.jsonl',
        freq: 'daily',
        relay: relay,
        check: check,
        build: e.populateMetadata
    }
  ];

  chartsConfig.forEach(config => {
    if (!config.elementId.startsWith('table')) {
        const chart = e.createEchartElement(config.elementId, currentTheme);
        if (chart) {
          e.loadJSONData(config.jsonPath, config.relay, (data) => {
          config.build(config, data, chart);}, chart);
        }
    } else {
      e.loadJSONData(config.jsonPath, config.relay, (data) => {
        config.build(config, data);});
    }
  });

}